<!-- Draggable Boundary to keep it on screen -->
<div class="drag-boundary">
  <!-- Draggable Floating Icon -->
  <div
    class="help-bot-container"
    cdkDrag
    cdkDragBoundary=".drag-boundary"
    (cdkDragStarted)="onDragStarted()"
    (cdkDragEnded)="onDragEnded()"
  >
    <div class="tooltip-label">Need Help?</div>
    <button class="help-bot-btn" (click)="openHelpModal($event)">?</button>
  </div>
</div>

<!-- Help Request Panel -->
<div
  class="custom-help-panel"
  [ngClass]="{ show: isModalOpen }"
  *ngIf="isModalOpen"
>
  <div class="panel-content">
    <div class="panel-header header-dark">
      <h5 class="panel-title text-white mb-0">Need Help?</h5>
      <button
        type="button"
        class="close text-white"
        aria-label="Close"
        (click)="closeHelpModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="panel-body p-4">
      <form #helpForm="ngForm" (ngSubmit)="onSubmit(helpForm)">
        <div class="form-group mb-3">
          <label class="font-weight-bold"
            >Full Name <span class="text-danger">*</span></label
          >
          <input
            type="text"
            class="form-control"
            name="fullName"
            [(ngModel)]="helpRequest.fullName"
            placeholder="John Doe"
            [ngClass]="{ 'is-invalid': fullNameError }"
          />
          <div class="invalid-feedback" *ngIf="fullNameError">
            Full Name is required.
          </div>
        </div>

        <div class="form-group mb-3">
          <label class="font-weight-bold"
            >Email <span class="text-danger">*</span></label
          >
          <input
            type="email"
            class="form-control"
            name="email"
            [(ngModel)]="helpRequest.email"
            placeholder="john@example.com"
            [ngClass]="{ 'is-invalid': emailError }"
          />
          <div class="invalid-feedback" *ngIf="emailError">
            Please enter a valid email.
          </div>
        </div>

        <div class="form-group mb-3">
          <label class="font-weight-bold"
            >Phone Number <span class="text-muted">(optional)</span></label
          >
          <input
            type="text"
            class="form-control"
            name="phone"
            [(ngModel)]="helpRequest.phone"
            placeholder="+1 (555) 000-0000"
            mask="(000) 000-0000"
            prefix="+1 "
            [ngClass]="{ 'is-invalid': phoneError }"
          />
          <div class="invalid-feedback" *ngIf="phoneError">
            Please enter a valid phone number.
          </div>
        </div>

        <div class="form-group mb-3">
          <label class="font-weight-bold"
            >Describe your issue <span class="text-danger">*</span></label
          >
          <textarea
            class="form-control"
            name="issueDescription"
            [(ngModel)]="helpRequest.issueDescription"
            rows="4"
            placeholder="Please describe your issue in detail..."
            maxlength="1000"
            [ngClass]="{ 'is-invalid': issueError }"
          ></textarea>
          <div class="invalid-feedback" *ngIf="issueError">
            Issue description is required.
          </div>
          <small class="form-text text-muted"
            >Please describe your issue in detail (max 1000 characters)</small
          >
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <button
            type="button"
            class="btn btn-outline-dark rounded-circle btn-close-circle"
            (click)="closeHelpModal()"
          >
            <i class="fa fa-times"></i>
          </button>
          <button type="submit" class="btn rounded-pill px-4 btn-submit">
            <i class="fa-regular fa-paper-plane mr-2"></i> Submit Request
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Success Panel -->
<div
  class="custom-help-panel success-help-panel"
  [ngClass]="{ show: isSuccessOpen }"
  *ngIf="isSuccessOpen"
>
  <div class="panel-content text-center">
    <div class="panel-header header-dark">
      <h5 class="panel-title text-white mb-0">Need Help?</h5>
      <button
        type="button"
        class="close text-white"
        aria-label="Close"
        (click)="closeSuccessModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="panel-body px-4 py-5">
      <div class="success-icon mb-4">
        <i class="fa fa-check-circle text-success" style="font-size: 4rem"></i>
      </div>
      <h5 class="font-weight-bold mb-2" style="color: #000; font-size: 1.25rem">
        Request Submitted Successfully
      </h5>
      <p
        class="text-muted mb-4"
        style="
          font-size: 1rem;
          line-height: 1.5;
          margin-bottom: 2rem !important;
          white-space: nowrap;
        "
      >
        Your request has been submitted successfully.<br />
        Our support team will contact you shortly.
      </p>
      <button
        type="button"
        class="btn btn-dark rounded-pill px-5 py-2"
        (click)="closeSuccessModal()"
      >
        Close
      </button>
    </div>
  </div>
</div>
